export { default as ContractSlot } from './ContractSlot';
